export const EMPTY_MODEL = {
  items: [],
}

export const EMPTY_MODEL_STRING = JSON.stringify(EMPTY_MODEL)
